<template>
  <div class="px-2 md:px-10 py-4">
    <!--Povrch-->
    <div class="sm:flex sm:flex-wrap -mx-2 mb-8">
      <!--Row 1-->
      <div class="w-full sm:w-1/2 lg:w-1/4 px-2 mb-4 flex flex-col">
        <div class="rounded overflow-hidden shadow-lg flex-grow">
          <div class="flex flex-col flex-1 justify-between">
            <div class="px-6 py-4 text-sm">
              <div class="flex justify-between items-center mb-2">
                <h3 class="font-bold text-lg uppercase">Povrch</h3>
                <span
                  class="flex-shrink-0 ml-2 inline-block bg-blue-500 px-2 py-1 rounded-full text-gray-100 shadow-md text-xxs"
                  href="#"
                >5. třída</span>
              </div>
              <div class="flex border-b pb-2">
                <div class="w-full md:w-1/3">
                  <h3 class="font-semibold">Nížiny</h3>
                </div>
                <div class="w-full md:w-2/3">
                  <h4>Východoevropská nížina</h4>
                  <h4>Středopolské nížiny</h4>
                  <h4>Francouzská nížina</h4>
                </div>
              </div>
              <div class="flex pt-2">
                <div class="w-full md:w-1/3">
                  <h3 class="font-semibold">Vysočiny</h3>
                </div>
                <div class="w-full md:w-2/3">
                  <h4>Alpy</h4>
                  <h4>Karpaty</h4>
                  <h4>
                    Česká vysočina
                    <span class="font-semibold text-red-700">ČR</span>
                  </h4>
                  <h4>Pyreneje</h4>
                  <h4>Balkán</h4>
                  <h4>Skandinávské pohoří</h4>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--end Povrch-->
      <!--Vodstvo-->
      <div class="w-full sm:w-1/2 lg:w-1/4 px-2 mb-4 flex flex-col">
        <div class="rounded overflow-hidden shadow-lg flex-grow">
          <div class="flex flex-col flex-1 justify-between">
            <div class="px-6 py-4 text-sm">
              <div class="flex justify-between items-center mb-2">
                <h3 class="font-bold text-lg uppercase">Vodstvo</h3>
                <span
                  class="flex-shrink-0 ml-2 inline-block bg-blue-500 px-2 py-1 rounded-full text-gray-100 shadow-md text-xxs"
                  href="#"
                >5. třída</span>
              </div>
              <div class="flex border-b pb-2">
                <div class="w-full md:w-1/3">
                  <h3 class="font-semibold">Slané vody</h3>
                </div>
                <div class="w-full md:w-2/3">
                  <h4>Atlantský oceán</h4>
                  <h4>Severní ledový oceán</h4>
                  <h4>Vnitřní moře (Jaderské)</h4>
                  <h4>Okrajové moře (Barentsovo)</h4>
                </div>
              </div>
              <div class="flex pt-2">
                <div class="w-full md:w-1/3">
                  <h3 class="font-semibold">Sladké vody</h3>
                </div>
                <div class="w-full md:w-2/3">
                  <h4>Říční síť potoků a řek</h4>
                  <h4>
                    <span class="font-semibold">Veletoky</span> - Volha, Dunaj, Rýn
                  </h4>
                  <h4>
                    <span class="font-semibold">Vodní nádrže</span> - Ladožské jezero
                  </h4>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--end Vodstvo-->
      <!--Poloostrovy a pásy-->
      <div class="w-full sm:w-1/2 lg:w-1/4 px-2 mb-4 flex flex-col">
        <div class="rounded overflow-hidden shadow-lg flex-grow">
          <div class="flex flex-col flex-1 justify-between">
            <div class="px-6 py-4 text-sm">
              <div class="flex justify-between items-center mb-2">
                <h3 class="font-bold text-lg uppercase">Poloostrovy</h3>
                <span
                  class="flex-shrink-0 ml-2 inline-block bg-blue-500 px-2 py-1 rounded-full text-gray-100 shadow-md text-xxs"
                  href="#"
                >5. třída</span>
              </div>
              <div class="pb-2">
                <div class="w-full">
                  <h4>Pyrenejský poloostrov</h4>
                  <h4>Apeninský poloostrov</h4>
                  <h4>Balkánský poloostrov</h4>
                  <h4>Skandinávský poloostrov</h4>
                </div>
              </div>
              <div class="flex justify-between items-center mb-2">
                <h3 class="font-bold text-lg uppercase">Podnebné pásy</h3>
                <span
                  class="flex-shrink-0 ml-2 inline-block bg-blue-500 px-2 py-1 rounded-full text-gray-100 shadow-md text-xxs"
                  href="#"
                >5. třída</span>
              </div>
              <div class="pb-2">
                <div class="w-full">
                  <h4>Subpolární pás</h4>
                  <h4>
                    Mírný pás
                    <span class="font-semibold text-red-700">ČR</span>
                  </h4>
                  <h4>Subtropický pás</h4>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--end Poloostrovy a pásy-->
      <!--Nerosty a podnebí-->
      <div class="w-full sm:w-1/2 lg:w-1/4 px-2 mb-4 flex flex-col">
        <div class="rounded overflow-hidden shadow-lg flex-grow">
          <div class="flex flex-col flex-1 justify-between">
            <div class="px-6 py-4 text-sm">
              <div class="flex justify-between items-center mb-2">
                <h3 class="font-bold text-lg uppercase">Nerosty</h3>
                <span
                  class="flex-shrink-0 ml-2 inline-block bg-blue-500 px-2 py-1 rounded-full text-gray-100 shadow-md text-xxs"
                  href="#"
                >5. třída</span>
              </div>
              <div class="pb-2">
                <div class="w-full">
                  <h4>Černé uhlí</h4>
                  <h4>Hnědé uhlí</h4>
                  <h4>Železná ruda</h4>
                  <h4>Uranová ruda</h4>
                </div>
              </div>
              <div class="flex justify-between items-center mb-2">
                <h3 class="font-bold text-lg uppercase">Podnebí</h3>
                <span
                  class="flex-shrink-0 ml-2 inline-block bg-blue-500 px-2 py-1 rounded-full text-gray-100 shadow-md text-xxs"
                  href="#"
                >5. třída</span>
              </div>
              <div class="pb-2">
                <div class="w-full">
                  <h4>Přímořské - oceánské</h4>
                  <h4>
                    Přechodné - proměnlivé
                    <span class="font-semibold text-red-700">ČR</span>
                  </h4>
                  <h4>Vnitrozemské - kontinentální</h4>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--end Nerosty a podnebí-->
    </div>
    <!--cards flex wrapper-->
    <!--new cards flex wapper-->
    <div class="sm:flex sm:flex-wrap -mx-2">
      <!--Poloha ČR-->
      <div class="w-full sm:w-1/2 lg:w-1/3 px-2 mb-4 flex flex-col">
        <div class="rounded overflow-hidden shadow-lg flex-grow">
          <div class="flex flex-col flex-1 justify-between">
            <div class="px-6 py-4 text-sm">
              <div class="flex justify-between items-center mb-2">
                <h3 class="font-bold text-lg uppercase">Poloha ČR v Evropě</h3>
                <span
                  class="flex-shrink-0 ml-2 inline-block bg-blue-500 px-2 py-1 rounded-full text-gray-100 shadow-md text-xxs"
                  href="#"
                >5. třída</span>
              </div>
              <div class="pb-2">
                <div class="w-full">
                  <h4>
                    Sřední Evropa
                    <span class="font-semibold text-red-700">ČR</span>
                  </h4>

                  <h4>Severní Evropa</h4>
                  <h4>Jižní Evropa</h4>
                  <h4>Západní Evropa</h4>
                  <h4>Jihovýchodní Evropa</h4>
                  <h4>Východní Evropa</h4>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--end Poloha ČR-->
      <!--Vegetace-->
      <div class="w-full sm:w-1/2 lg:w-1/3 px-2 mb-4 flex flex-col">
        <div class="rounded overflow-hidden shadow-lg flex-grow">
          <div class="flex flex-col flex-1 justify-between">
            <div class="px-6 py-4 text-sm">
              <div class="flex justify-between items-center mb-2">
                <h3 class="font-bold text-lg uppercase">Vegetace Evropy</h3>
                <span
                  class="flex-shrink-0 ml-2 inline-block bg-blue-500 px-2 py-1 rounded-full text-gray-100 shadow-md text-xxs"
                  href="#"
                >5. třída</span>
              </div>
              <div class="pb-2">
                <div class="w-full">
                  <h4>Polární pustiny a tundry</h4>
                  <h4>Jehličnaté lesy</h4>
                  <h4>
                    Smíšené a listnaté lesy
                    <span class="font-semibold text-red-700">ČR</span>
                  </h4>
                  <h4>Stepi</h4>
                  <h4>Subtropická krajina</h4>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--end Vegetace-->
      <!--Obyvatelsvo-->
      <div class="w-full sm:w-1/2 lg:w-1/3 px-2 mb-4 flex flex-col">
        <div class="rounded overflow-hidden shadow-lg flex-grow">
          <div class="flex flex-col flex-1 justify-between">
            <div class="px-6 py-4 text-sm">
              <div class="flex justify-between items-center mb-2">
                <h3 class="font-bold text-lg uppercase">Obyvatelstvo Evropy</h3>
                <span
                  class="flex-shrink-0 ml-2 inline-block bg-blue-500 px-2 py-1 rounded-full text-gray-100 shadow-md text-xxs"
                  href="#"
                >5. třída</span>
              </div>
              <div class="pb-2">
                <div class="w-full">
                  <h4>Slovanské</h4>
                  <h4>Germánské</h4>
                  <h4>Románské</h4>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--end Obyvatelsvo-->
    </div>
  </div>
</template>

<script>
export default {
  name: "Europe",
  components: {},
  methods: {
    say: function(message) {
      alert(message);
    }
  }
};
</script>

<style></style>
